<div 
    *ngIf="activity"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();"
>
    <div class="w-full max-w-screen-md max-h-[90%] flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <div
                class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
            >
                <div class="w-full flex flex-row items-center justify-between">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap">
                        Activity: <span class="text-nside-orange-400">{{ activity.activity_name }}</span>
                    </h2>
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeModal();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full overflow-y-auto flex flex-col items-center p-4 rounded-lg">
                    <!-- Full detail set: AL only. MS shows event name + courses of action. -->
                    <ng-container *ngIf="showFullDetails">
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Location</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.location }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Primary Contact:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.primary_contact_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Secondary Contact:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.secondary_contact_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Emergency Equipment:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.emergency_equipment }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>First Aid:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.first_aid_contact_names }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>CPR:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.cpr_contact_names }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>AED:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.aed_contact_names }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Incident Reporting Procedures:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.incident_reporting_contact_names }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Individual Emergency Action Plans (IEAP):</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.ieap_contact_names }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Emergency Diabetic Medications:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.emergency_diabetic_contact_names }}</p>
                        </div>
                    </div>
                    </ng-container>
                    <div class="w-full flex items-start text-start p-2 bg-gray-100">
                        <div class="w-44 shrink-0 flex items-start text-nside-gray-300">
                            <p>Courses of Action:</p>
                        </div>
                        <div class="flex-grow min-w-0 flex items-start">
                            <!-- Entered in a textarea, so keep the author's line breaks and indentation. -->
                            <p class="w-full whitespace-pre-wrap break-words">{{ activity.courses_of_action }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Last Updated By:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.last_updated_user_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Last Updated At:</p>
                        </div>
                        <div class="flex-grow flex items-center">
                            <p>{{ activity.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</p>
                        </div>
                    </div>
                </div>

                <div class="w-full flex gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</div>